import { createSlice } from '@reduxjs/toolkit';

export const callTranscriptionSlice = createSlice({
  name: 'callTranscription',
  initialState: {
    isPlaying: false,
    millisecond: 0,
  },
  reducers: {
    toggleIsPlaying: (state, action) => {
      state.isPlaying = action.payload;
    },
    updateMillisecond: (state, action) => {
      state.millisecond = action.payload;
    },
  },
});

export const {
  toggleIsPlaying,
  updateMillisecond,
} = callTranscriptionSlice.actions;

export default callTranscriptionSlice.reducer;
